import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';

export type V_UserSubLibrary = {
  '@id': string;
  '@type': 'UserContentView';
  libraryContent: {
    '@id': string;
    '@type': 'LibraryContent';
    title: string;
    question: string | null;
    userAnswer: {
      '@id': string;
      '@type': 'UserSimpleAnswer';
      answer: string;
    } | null;
  } | null;
  viewedAt: string;
};

export type W = {
  libraryContent: string | null;
  dailyTip: string | null;
  weeklyTask: string | null;
};

export function useReadCollectionLibraryContentViews(
  id: string,
  queryParams?: {
    answersOnly?: string;
    'exists[libraryContent]'?: boolean;
    'libraryContent.title'?: string;
    'order[viewedAt]'?: string;
  },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_UserSubLibrary>>(
    `/users/${id}/library-content-views${makeQueryString(queryParams)}`,
    options,
  );
}
